<template>
  <div class="grid">
    <div class="grid col-12">
      <div class="col-6 md:col-4">
        <Dropdown style="width: 100%"
          v-model="selectedUnidadFiltro"
          :options="lstUnidades"
          optionLabel="UNIDAD_SUBRED"
          placeholder="Filtrar por unidad"
          :showClear="true"
          :filter="true"
          @change="Filtrar"
        />
      </div>
      <div class="col-6 md:col-3">
        <Dropdown style="width: 100%"
          v-model="selectedEstatusFiltro"
          :options="lstEstatus"
          placeholder="Estatus"
          optionLabel="Descripcion"
          :showClear="true"
          @change="Filtrar"
        />
      </div>
      <!-- <div class="col">
            <Button label="Filtrar" @click="BuscarUnidad"/> 
          </div>  -->
      <div class="col-6 md:col-3">
        <div class="p-inputgroup">
          <InputText class="col-12" placeholder="Folio" v-model="FolioBuscar" />
          <Button icon="pi pi-search" @click="buscarFolio" />
        </div>
      </div>
      <div class="col-6 md:col-2">
        <Button
          style="width: 100%"
          @click="abreAgregar"
          icon="pi pi-plus"
          label="Nuevo"
        />
      </div>
    </div>

    <div v-show="!lstReportes || lstReportes.length <= 0" class="col-12 px-4">
      <p>NO SE ENCONTRARÓN REPORTES</p>
    </div>

    <div
      v-for="item in lstReportes"
      :key="item.Id_reporte_telmex"
      class="col-12 md:col-4"
    >
      <div class="card pb-0" style="height: 100%">
        <div class="card-header no-border">
          <h5 v-if="item.Folio_reporte" class="card-title">
            Folio {{ item.Folio_reporte }}
          </h5>
          <h5 v-else class="card-title">NO REPORTADO</h5>
          <Button
            @click="abreDetalle(item)"
            icon="pi pi-eye"
            class="p-button-rounded p-button-outlined mr-0 ml-auto"
          />
        </div>
        <div class="card-body pt-0">
          <div class="widget-49">
            <div
              v-tooltip.top="getTooltip(item)"
              class="widget-49-title-wrapper"
            >
              <div :class="getClass(item)">
                <span class="widget-49-date-day">{{
                  getDateWCF(item.Fecha_alta).getDate()
                }}</span>
                <span class="widget-49-date-month">{{
                  getMonthText(getDateWCF(item.Fecha_alta).getMonth())
                }}</span>
              </div>
              <div class="widget-49-meeting-info">
                <span class="widget-49-pro-title">{{ item.Unidad }}</span>
                <span class="widget-49-meeting-time">{{
                  getEstatusText(item.Id_estatus)
                }}</span>
              </div>
            </div>

            <div class="grid">
              <!-- <div class="col widget-49-meeting-points">
                <div class="titulo">ID</div>
                <i class="pi pi-flag" /><span class="detalle pl-2">{{
                  item.Id_linea_telefonica
                }}</span>
              </div> -->
              <div class="col widget-49-meeting-points">
                <div class="titulo">Teléfono</div>
                <i class="pi pi-phone" /><span class="detalle pl-2">{{
                  item.Num_telefonico
                }}</span>
              </div>
            </div>
            <div class="grid">
              <div class="col widget-49-meeting-points">
                <div class="titulo">Reportado</div>
                <i class="pi pi-send" /><span v-if="item.Fecha_reporte" class="detalle pl-2">{{
                  getFechaWCF(item.Fecha_reporte, false)
                }}</span><span v-else class="detalle pl-2">N/D</span>
              </div>
              <div class="col widget-49-meeting-points">
                <div class="titulo">Atendido</div>
                <i class="pi pi-check-circle" /><span v-if="item.Fecha_resolucion" class="detalle pl-2">{{
                  getFechaWCF(item.Fecha_resolucion, false)
                }}</span><span v-else class="detalle pl-2">N/D</span>
              </div>
            </div>
            <div class="grid">
              <div class="col widget-49-meeting-points">
                <div class="titulo">Confirmado</div>
                <i class="pi pi-thumbs-up" style="color: green" />
                <span v-if="item.Fecha_comprobacion" class="detalle pl-2">{{ getFechaWCF(item.Fecha_comprobacion, false) }}</span>
                <span v-else class="detalle pl-2">N/D</span>
              </div>
              <div class="col widget-49-meeting-points">
                <div class="titulo">Técnico</div>
                <i class="pi pi-user" /><span
                  v-if="item.Tecnico"
                  class="detalle pl-2"
                  >{{ item.Tecnico }}</span
                ><span v-else class="detalle pl-2">N/D</span>
              </div>
            </div>

            <div class="grid p-mt-2 flex justify-content-end">
              <Button
                v-if="item.Id_estatus >= 1 && item.Id_estatus < 5"
                icon="pi pi-plus"
                label="Acción"
                class="p-button-text"
                @click="abreAddDetalle(item)"
              />
              <Button
                v-if="item.Id_estatus == 1"
                icon="pi pi-exclamation-triangle"
                label="Reportar"
                class="p-button-text p-button-danger"
                @click="abreCambioEstatus(item)"
              />
              <Button
                v-else-if="item.Id_estatus == 2"
                icon="pi pi-check"
                label="Atendido"
                class="p-button-text p-button-success"
                @click="abreCambioEstatus(item)"
              />
              <Button
                v-else-if="item.Id_estatus == 3"
                icon="pi pi-thumbs-up"
                label="Comprobar"
                class="p-button-text p-button-info"
                @click="abreCambioEstatus(item)"
              />
              <Button
                v-else-if="item.Id_estatus == 4"
                icon="pi pi-flag"
                label="Finalizar"
                class="p-button-text p-button-help"
                @click="abreCambioEstatus(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      :style="{ width: '550px' }"
      :visible="showAgregar"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>Agregar reporte</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="unidad">Unidad</label>
          <Dropdown
            id="unidad"
            appendTo="body"
            v-model="objAgregar.tUnidad"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :filter="true"
            :class="{
              'p-invalid': submitted && !objAgregar.tUnidad,
            }"
          />
          <small class="p-invalid" v-if="submitted && !objAgregar.tUnidad"
            >La unidad es requerida.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="responsable">Responsable</label>
          <InputText
            autocomplete="off"
            id="responsable"
            v-model.trim="objAgregar.Responsable"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !objAgregar.Responsable }"
          />
          <small class="p-invalid" v-if="submitted && !objAgregar.Responsable"
            >El Responsable es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Cargo">Cargo responsable</label>
          <InputText
            autocomplete="off"
            id="Cargo"
            v-model.trim="objAgregar.Cargo_responsable"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field col">
          <label for="Telefono">Teléfono</label>
          <InputText
            autocomplete="off"
            id="Telefono"
            v-model.trim="objAgregar.Tel_responsable"
            required="true"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <!-- <div class="p-field col">
          <label for="idliena">ID Línea</label>
          <InputText
            autocomplete="off"
            id="idliena"
            v-model.trim="objAgregar.Id_linea_telefonica"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !objAgregar.Id_linea_telefonica,
            }"
          />
          <small
            class="p-invalid"
            v-if="submitted && !objAgregar.Id_linea_telefonica"
            >El ID línea es requerida.</small
          >
        </div> -->
        <div class="p-field col">
          <label for="num_tel">No. teléfonico</label>
          <InputText
            autocomplete="off"
            id="num_tel"
            v-model.trim="objAgregar.Num_telefonico"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !objAgregar.Num_telefonico }"
          />
          <small
            class="p-invalid"
            v-if="submitted && !objAgregar.Num_telefonico"
            >El No. teléfonico es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Observación</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="objAgregar.Comentarios_alta"
            autofocus
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarobjAgregar"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '550px' }"
      :visible="showCambioEstatus"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ titulo_cambio_estatus }}</h3>
      </template>

      <div class="p-formgrid grid">
        <div
          v-show="objAgregar.Id_estatus == 2 || objAgregar.Id_estatus == 5"
          class="p-field col"
        >
          <label for="folio_reporte">{{
            objAgregar.Id_estatus == 1
              ? "Folio reporte"
              : objAgregar.Id_estatus == 5
              ? "Folio cierre"
              : "Folio"
          }}</label>
          <InputText
            autocomplete="off"
            id="folio_reporte"
            v-model.trim="objAgregar.Folio"
            required="true"
            autofocus
            :class="{
              'p-invalid': submittedCambioEstatus && !objAgregar.Folio,
            }"
          />
          <small
            class="p-invalid"
            v-if="submittedCambioEstatus && !objAgregar.Folio"
            >El folio es requerido.</small
          >
        </div>
        <div class="p-field col">
          <label for="fecha_cambio">Fecha</label>
          <Calendar
            appendTo="body"
            autocomplete="off"
            id="adquisicion"
            v-model="objAgregar.Fecha"
            :locale="es"
            :monthNavigator="true"
            :yearNavigator="true"
            yearRange="1950:2025"
            dateFormat="dd/mm/yy"
            :class="{
              'p-invalid': submittedCambioEstatus && !objAgregar.Fecha,
            }"
            @date-select="dateSelect"
          />
          <small
            class="p-invalid"
            v-if="submittedCambioEstatus && !objAgregar.Fecha"
            >La fecha es requerida.</small
          >
        </div>
      </div>

      <div
        v-show="objAgregar.Id_estatus == 1 || objAgregar.Id_estatus == 2"
        class="p-formgrid grid"
      >
        <div class="p-field col">
          <label for="tecnico">Técnico</label>
          <InputText
            autocomplete="off"
            id="tecnico"
            v-model.trim="objAgregar.Tecnico"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Observación</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="objAgregar.Comentarios"
            autofocus
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogoCambioEstatus"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarCambioEstatus"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '550px' }"
      :visible="showAgregaDetalle"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>Agregar detalle</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="fecha_cambio">Fecha</label>
          <Calendar
            appendTo="body"
            autocomplete="off"
            id="adquisicion"
            v-model="objAddDetalle.Fecha"
            :locale="es"
            :monthNavigator="true"
            :yearNavigator="true"
            yearRange="1950:2025"
            dateFormat="dd/mm/yy"
            :class="{
              'p-invalid': submittedAddDetalle && !objAddDetalle.Fecha,
            }"
            @date-select="dateSelect"
          />
          <small
            class="p-invalid"
            v-if="submittedAddDetalle && !objAddDetalle.Fecha"
            >La fecha es requerida.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Actividad">Actividad</label>
          <InputText
            autocomplete="off"
            id="Actividad"
            v-model.trim="objAddDetalle.Actividad"
            autofocus
            :class="{
              'p-invalid': submittedAddDetalle && !objAddDetalle.Actividad,
            }"
          />
          <small
            class="p-invalid"
            v-if="submittedAddDetalle && !objAddDetalle.Actividad"
            >La actividad es requerida.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Observación</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="objAddDetalle.Comentarios"
            autofocus
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogoAddDetalle"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarDetalle"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '650px' }"
      :visible="showDetalle"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
       <h3>Detalles</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <span class="detalle"><b>{{
            getEstatusText(objDetalle.Id_estatus)
          }}</b></span>
        </div>
      </div>
      
      <p><b>Datos de la ubicación</b></p>
      <div class="grid">
        <div class="p-field col-6">
          <i class="pi pi-map-marker p-mr-1" /><label>Unidad</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Unidad }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-calendar-plus p-mr-1" /><label>Fecha alta</label>
          <div>
            <span class="detalle pl-2">{{
              getFechaWCF(objDetalle.Fecha_alta, false)
            }}</span>
          </div>
        </div>
        <!-- <div class="p-field col-3">
          <i class="pi pi-sitemap p-mr-1" /><label>ID línea</label>
          <div>
            <span class="detalle pl-2">{{
              objDetalle.Id_linea_telefonica
            }}</span>
          </div>
        </div> -->
        <div class="p-field col-3">
          <i class="pi pi-phone p-mr-1" /><label>Teléfono</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Num_telefonico }}</span>
          </div>
        </div>
      </div>
      <p><b>Datos del responsable</b></p>
      <div class="p-formgrid grid">
        <div class="p-field col-3">
          <i class="pi pi-user p-mr-1" /><label>Responsable</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Responsable }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-paperclip p-mr-1" /><label>Cargo</label>
          <div>
            <span class="detalle pl-2">{{
              objDetalle.Cargo_responsable
            }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-phone p-mr-1" /><label>Tel. responsable</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Tel_responsable }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-comments p-mr-1" /><label>Comentario alta</label>
          <div>
            <span
              class="detalle pl-2"
              v-tooltip.top="objDetalle.Comentarios_alta"
              >{{
                objDetalle.Comentarios_alta ? objDetalle.Comentarios_alta.length > 15 ?
                objDetalle.Comentarios_alta.substring(0, 15) + "..." : objDetalle.Comentarios_alta
                : ""
              }}</span
            >
          </div>
        </div>
      </div>
      
      <p><b>Historial de cambios</b></p>

      <hr />

      <div class="p-formgrid grid">
        <div class="p-field col-3">
          <i class="pi pi-calendar p-mr-1" /><label>Fecha reporte</label>
          <div>
            <span class="detalle pl-2">{{
              getFechaWCF(objDetalle.Fecha_reporte)
            }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-pencil p-mr-1" /><label>Folio reporte</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Folio_reporte }}</span>
          </div>
        </div>

        <div class="p-field col-5">
          <i class="pi pi-comments p-mr-1" /><label>Comentario reporte</label>
          <div>
            <span
              class="detalle pl-2"
              v-tooltip.top="objDetalle.Comentarios_reportado"
              >{{
                objDetalle.Comentarios_reportado ? objDetalle.Comentarios_reportado.length > 15 ?
                objDetalle.Comentarios_reportado.substring(0, 15) + "..." : objDetalle.Comentarios_reportado
                : ""
              }}</span
            >
          </div>
        </div>
      </div>

      <hr />

      <div class="p-formgrid grid">
        <div class="p-field col-3">
          <i class="pi pi-calendar p-mr-1" /><label>Fecha atención</label>
          <div>
            <span class="detalle pl-2">{{
              getFechaWCF(objDetalle.Fecha_resolucion)
            }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-user p-mr-1" /><label>Técnico</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Tecnico }}</span>
          </div>
        </div>
        <div class="p-field col-5">
          <i class="pi pi-comments p-mr-1" /><label>Comentario atención</label>
          <div>
            <span
              class="detalle pl-2"
              v-tooltip.top="objDetalle.Comentarios_resolucion"
              >{{
                objDetalle.Comentarios_resolucion ? objDetalle.Comentarios_resolucion.length > 15 ?
                objDetalle.Comentarios_resolucion.substring(0, 15) + "..." : objDetalle.Comentarios_resolucion
                : ""
              }}</span
            >
          </div>
        </div>
      </div>

      <hr />

      <div class="p-formgrid grid">
        <div class="p-field col-6">
          <i class="pi pi-calendar p-mr-1" /><label>Fecha comprobación</label>
          <div>
            <span class="detalle pl-2">{{
              getFechaWCF(objDetalle.Fecha_comprobacion)
            }}</span>
          </div>
        </div>
        <div class="p-field col-6">
          <i class="pi pi-comments p-mr-1" /><label
            >Comentario comprobación</label
          >
          <div>
            <span
              class="detalle pl-2"
              v-tooltip.top="objDetalle.Comentarios_comprobacion"
              >{{
                objDetalle.Comentarios_comprobacion ? objDetalle.Comentarios_comprobacion.length > 55 ?
                objDetalle.Comentarios_comprobacion.substring(0, 35) + "..." : objDetalle.Comentarios_comprobacion
                : ""
              }}</span
            >
          </div>
        </div>
      </div>

      <hr />

      <div class="p-formgrid grid">
        <div class="p-field col-3">
          <i class="pi pi-calendar-times p-mr-1" /><label>Fecha cierre</label>
          <div>
            <span class="detalle pl-2">{{
              getFechaWCF(objDetalle.Fecha_cierre)
            }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-pencil p-mr-1" /><label>Folio cierre</label>
          <div>
            <span class="detalle pl-2">{{ objDetalle.Folio_cierre }}</span>
          </div>
        </div>
        <div class="p-field col-3">
          <i class="pi pi-comments p-mr-1" /><label>Comentario cierre</label>
          <div>
            <span
              class="detalle pl-2"
              v-tooltip.top="objDetalle.Comentarios_cierre"
              >{{
                  objDetalle.Comentarios_cierre ? objDetalle.Comentarios_cierre.length > 15 ?
                  objDetalle.Comentarios_cierre.substring(0, 15) + "..." : objDetalle.Comentarios_cierre
                  : ""
              }}</span
            >
          </div>
        </div>
      </div>

      <hr />

<!-- Sección de acciones -->
    <template>
      <h5>Acciones</h5>
    </template>

    <!-- COLUMNAS DE ACCIONES -->              
    <template>
      <div>
        <DataTable 
        :value="lstAcciones">
            <Column header="Fecha de acción" headerStyle="padding: 1rem 0rem;">
              <template #body="slotProps">
                 <span>{{getFechaWCF(slotProps.data.Fecha, false)}}</span>
              </template>
            </Column>
            <Column header="Acción">
             <template #body="slotProps">  <!-- #body="slotProps" -->
               <span v-tooltip.top="slotProps.data.Actividad">{{
                 slotProps.data.Actividad ? slotProps.data.Actividad.length > 40 ?
                 slotProps.data.Actividad.substring(0, 40) + "...":slotProps.data.Actividad
                 : ""
               }}
                </span>
              </template> 
            </Column>
            <Column header="Observación">
              <template #body="slotProps">
               <span  v-tooltip.top="slotProps.data.Comentarios">{{
                slotProps.data.Comentarios ? slotProps.data.Comentarios.length > 40 ?
                slotProps.data.Comentarios.substring(0, 40) + "...":slotProps.data.Comentarios
                : ""
              }}
              </span> 
              </template>
            </Column>
        </DataTable>
    </div>
</template>

      <template #footer>
        <Button
          label="Cerrar"
          icon="pi pi-sign-out"
          class="p-button-text"
          @click="showDetalle = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Srvr from "../service/Inventario";
import SrvrReportes from "../service/Reportes_telmex";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: true,
      showAgregar: false,
      objAgregar: {},
      lstUnidades: [],
      submitted: false,
      lstReportes: [],
      submittedCambioEstatus: false,
      showCambioEstatus: false,
      titulo_cambio_estatus: "",
      es: {
        firstDayOfWeek: 1,
        dayNames: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        clear: "Borrar",
        weekHeader: "Sm",
      },
      //Estatus: null,
      lstEstatus:[
        {Id: 1, Descripcion:"CREADO"},
        {Id: 2, Descripcion: "REPORTADO"},
        {Id: 3, Descripcion: "ATENDIDO"},
        {Id: 4, Descripcion: "COMPROBADO"},
        {Id: 5, Descripcion: "FINALIZADO"}, 
      ],
      selectedUnidadFiltro: null,
      selectedEstatusFiltro: null,
      showDetalle: false,
      objDetalle: {},
      showAgregaDetalle: false,
      objAddDetalle: {},
      submittedAddDetalle: false,
      FolioBuscar: null,
      lstAcciones: [],
    };
  },
  methods: {
    BuscarPorAccion(Id){
     
      var t = this;
      var ctlSrvReportes = new SrvrReportes();

      ctlSrvReportes.getDetalleReporte(t,Id).then((res) => {
      t.lstAcciones = res;
      // console.log(t.lstAcciones);
      });    
    },                                                                                      
    Filtrar() {
      var t = this;
      var ctlSvr = new SrvrReportes();
      if (t.selectedUnidadFiltro) {  //se vaida si unidad es vacio, null or undefined
        if (t.selectedEstatusFiltro) { //se vaida si estatus es vacio, null or undefined
          //console.log("filtro por ambos");
           ctlSvr = new SrvrReportes();
           ctlSvr.getBuscarPorUnidadEstatus(t,t.selectedUnidadFiltro.UNIDAD,t.selectedEstatusFiltro.Id).then(res =>{
           t.lstReportes = res;           
          }); 
        } else {
          //console.log("solo filtro por unidad");
            ctlSvr = new SrvrReportes();
            ctlSvr.getBuscarPorUnidad(t,t.selectedUnidadFiltro.UNIDAD).then(res => {
            t.lstReportes = res;
           });
        }
      } else {
        if (t.selectedEstatusFiltro) {
          //console.log("filtro solo por estatus");
          ctlSvr.getBuscarEstatus(t,t.selectedEstatusFiltro.Id).then((res) => {
            t.lstReportes = res;
           });          
        } else {
          //console.log("muestra todos los reportes");
          t.getAllReportes();
        }
      }
    },
    BuscarUnidad() {
      //console.log(this.selectedUnidadFiltro.UNIDAD);
      var t = this;
      var ctlSvr = new SrvrReportes();

      ctlSvr.getBuscarPorUnidad(t, t.selectedUnidadFiltro.UNIDAD).then((res) => {
          t.lstReportes = res;
        });
    },
    BuscarEstatus() {
      //console.log(t.selectedEstatusFiltro.Id);
      var t = this;
      var ctlSvr = new SrvrReportes();
      

      ctlSvr.getBuscarEstatus(t, t.selectedEstatusFiltro.Id).then((res) => {
          t.lstReportes = res;
        });
    },
    BuscarPorUnidadEstatus() {
      // console.log(this.selectedUnidadFiltro.UNIDAD);
      // console.log(this.selectedEstatusFiltro.Id);
      var t = this;
      var ctlSvr = new SrvrReportes();

      ctlSvr.geBuscarPorUnidadEstatus(t,t.selectedUnidadFiltro.UNIDAD,t.selectedEstatusFiltro.Id).then((res) => {
          t.lstReportes = res;
        });
    },
    buscarFolio() {
      //console.log(this.FolioBuscar);
      var t = this;
      var ctlSrvReportes = new SrvrReportes();

      if(t.FolioBuscar){
        ctlSrvReportes.getBuscarPorFolio(t, t.FolioBuscar).then((res) => {
        t.lstReportes = res;
        });
      }else{
        t.getAllReportes();
      }  
    },
    abreAddDetalle(item) {
      var t = this;
      t.objAddDetalle = {};
      t.showAgregaDetalle = true;
      t.submittedAddDetalle = false;
      t.objAddDetalle.Id_reporte_telmex = item.Id_reporte_telmex;
      t.objAddDetalle.Fecha = new Date();
    },
    abreDetalle(item) {
      var t = this;
      t.showDetalle = true;
      t.objDetalle = { ...item };
      //console.log(item);
      t.BuscarPorAccion(item.Id_reporte_telmex);
    },
    getDateDiff(inicio, fin) {
      var fechaInicio = inicio;
      var fechaFin = fin;

      var diff = fechaFin - fechaInicio;

      return diff / (1000 * 60 * 60 * 24);
    },
    getTooltip(item) {
      var fecha_actual = new Date();
      var fecha_creo = this.getDateWCF(item.Fecha_alta);
      var fecha_reporte = this.getDateWCF(item.Fecha_reporte);
      var fecha_resolucion = this.getDateWCF(item.Fecha_resolucion);
      var fecha_comprobacion = this.getDateWCF(item.Fecha_comprobacion);

      switch (item.Id_estatus) {
        case 1: //CREADO
          var diff = this.getDateDiff(fecha_creo, fecha_actual);
          if (diff >= 2) return "Reporte con 2 o más días sin ser reportado";
          break;
        case 2: //REPORTADO
          var diff2 = this.getDateDiff(fecha_reporte, fecha_actual);
          if (diff2 >= 2) return "Reporte con 2 o más días sin ser atendido";
          break;
        case 3: //REPARADO
          var diff3 = this.getDateDiff(fecha_resolucion, fecha_actual);
          if (diff3 >= 1) return "Reporte atendido sin ser comprobado";
          break;
        case 4: //CONFIRMADO
          var diff4 = this.getDateDiff(fecha_resolucion, fecha_comprobacion);
          if (diff4 >= 1) return "Reporte confirmado y aún no se a finalizado";
          break;
      }
    },
    getClass(item) {
      var fecha_actual = new Date();
      var fecha_creo = this.getDateWCF(item.Fecha_alta);
      var fecha_reporte = this.getDateWCF(item.Fecha_reporte);
      var fecha_resolucion = this.getDateWCF(item.Fecha_resolucion);
      var fecha_comprobacion = this.getDateWCF(item.Fecha_comprobacion);

      switch (item.Id_estatus) {
        case 1: //CREADO
          var diff = this.getDateDiff(fecha_creo, fecha_actual);
          if (diff >= 2) return "widget-49-date-danger";
          else return "widget-49-date-secondary";
        case 2: //REPORTADO
          var diff2 = this.getDateDiff(fecha_reporte, fecha_actual);
          if (diff2 >= 2) return "widget-49-date-danger";
          else return "widget-49-date-primary";
        case 3: //REPARADO
          var diff3 = this.getDateDiff(fecha_resolucion, fecha_actual);
          if (diff3 >= 1) return "widget-49-date-danger";
          else return "widget-49-date-primary";
        case 4: //CONFIRMADO
          var diff4 = this.getDateDiff(fecha_resolucion, fecha_comprobacion);
          if (diff4 >= 1) return "widget-49-date-danger";
          else return "widget-49-date-success";
        case 5: //FINALIZADO
          return "widget-49-date-comprobado";
      }
    },
    dateSelect() {
      this.$forceUpdate();
    },
    abreCambioEstatus(obj) {
      var t = this;
      t.objAgregar = { ...obj };
      switch (t.objAgregar.Id_estatus) {
        case 1:
          t.titulo_cambio_estatus = "REPORTAR A TELMEX";
          t.objAgregar.Id_estatus = t.objAgregar.Id_estatus + 1;
          t.objAgregar.Id_usuario_reporto =
            t.getUsuarioLogueado.Usuario.Id_usuario;
          t.showCambioEstatus = true;
          t.submittedCambioEstatus = false;
          break;
        case 2:
          t.titulo_cambio_estatus = "MARCAR COMO ATENDIDO";
          t.objAgregar.Id_estatus = t.objAgregar.Id_estatus + 1;
          t.showCambioEstatus = true;
          t.submittedCambioEstatus = false;
          break;
        case 3:
          t.titulo_cambio_estatus = "COMPROBAR FUNCIONAMIENTO";
          t.objAgregar.Id_estatus = t.objAgregar.Id_estatus + 1;
          t.showCambioEstatus = true;
          t.submittedCambioEstatus = false;
          break;
        case 4:
          t.titulo_cambio_estatus = "FINALIZAR REPORTE";
          t.objAgregar.Id_estatus = t.objAgregar.Id_estatus + 1;
          t.showCambioEstatus = true;
          t.submittedCambioEstatus = false;
          break;
      }
    },
    getEstatusText(id) {
      var t = this;
      if(t.lstEstatus[id - 1]){
        return t.lstEstatus[id - 1].Descripcion;
      } 
    },
    getMonthText(month) {
      const months = [
        "ENE",
        "FEB",
        "MAR",
        "ABR",
        "MAY",
        "JUN",
        "JUL",
        "AGO",
        "SEP",
        "OCT",
        "NOV",
        "DIC",
      ];
      return months[month];
    },
    getDateWCF(fecha) {
      if (fecha) {
        var millis = fecha
          .replace("/Date(", "")
          .replace("/", "")
          .replace(")", "");

        millis = millis * 1;

        if (millis > 0) {
          var mfecha = new Date(millis);

          return mfecha;
        } else {
          return "N/D";
        }
      }
    },
    getFechaWCF(fecha, hora) {
      if (fecha) {
        var millis = fecha
          .replace("/Date(", "")
          .replace("/", "")
          .replace(")", "");

        millis = millis * 1;

        if (millis > 0) {
          var mfecha = new Date(millis);

          var res =
            mfecha.getDate() < 10 ? "0" + mfecha.getDate() : mfecha.getDate();
          res += "/";
          res +=
            mfecha.getMonth() + 1 < 10
              ? "0" + (mfecha.getMonth() + 1)
              : mfecha.getMonth() + 1;
          res += "/";
          res += mfecha.getFullYear();

          if (hora) {
            res += " ";
            res += mfecha.getHours();
            res += ":";
            res +=
              mfecha.getMinutes() < 10
                ? "0" + mfecha.getMinutes()
                : mfecha.getMinutes();
          }

          return res;
        } else {
          return "N/D";
        }
      }
    },
    formateaFechaAMD(fecha) {
      if (fecha) {
        return "/Date(" + fecha.getTime() + ")/";
      } else {
        return null;
      }
    },
    getAllReportes() {
      var t = this;
      var ctlSrvReportes = new SrvrReportes();

      ctlSrvReportes.getReportes(t).then((res) => {
        t.lstReportes = res;
        
      });
    },
    abreAgregar() {
      var t = this;
      t.objAgregar = {};
      t.showAgregar = true;
      t.submitted = false;
    },
    cancelarDialogoCambioEstatus() {
      this.showCambioEstatus = false;
    },
    cancelarDialogoAddDetalle() {
      this.showAgregaDetalle = false;
    },
    cancelarDialogo() {
      this.showAgregar = false;
    },
    guardarDetalle() {
      var t = this;

      //console.log(t.objAddDetalle);

      t.submittedAddDetalle = true;

      if (
        !t.objAddDetalle ||
        !t.objAddDetalle.Fecha ||
        !t.objAddDetalle.Actividad
      )
        return;
      t.objAddDetalle.Fecha = t.formateaFechaAMD(t.objAddDetalle.Fecha);
      var ctlSrvReportes = new SrvrReportes();

      ctlSrvReportes
        .addDetalleReporte(t, t.objAddDetalle)
        .then((res) => {
          if (res) {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Detalle agregado",
              life: 3000,
            });
            t.cancelarDialogoAddDetalle();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    guardarobjAgregar() {
      var t = this;

      t.submitted = true;

      if (
        !t.objAgregar ||
        !t.objAgregar.tUnidad ||
        !t.objAgregar.Responsable ||
        // !t.objAgregar.Id_linea_telefonica ||
        !t.objAgregar.Num_telefonico
      )
        return;

      var ctlSrvReportes = new SrvrReportes();

      t.objAgregar.Unidad = t.objAgregar.tUnidad.UNIDAD;
      t.objAgregar.Id_usuario_creo = t.getUsuarioLogueado.Usuario.Id_usuario;
      t.objAgregar.Folio_reporte = t.objAgregar.Folio;

      ctlSrvReportes
        .addReporte(t, t.objAgregar)
        .then((res) => {
          t.lstReportes.push(res);
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Reporte agregado",
            life: 3000,
          });
          t.cancelarDialogo();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    guardarCambioEstatus() {
      var t = this;

      t.submittedCambioEstatus = true;

      switch (t.objAgregar.Id_estatus) {
        case 2: //REPORTADO
          if (!t.objAgregar.Folio || !t.objAgregar.Fecha) return;
          t.objAgregar.Folio_reporte = t.objAgregar.Folio;
          t.objAgregar.Fecha_cierre = null;
          t.objAgregar.Fecha_comprobacion = null;
          t.objAgregar.Fecha_resolucion = null;
          t.objAgregar.Comentarios_comprobacion = null;
          t.objAgregar.Fecha_reporte = t.formateaFechaAMD(t.objAgregar.Fecha);
          t.objAgregar.Id_usuario_reporto =
            t.getUsuarioLogueado.Usuario.Id_usuario;
          t.objAgregar.Comentarios_reportado = t.objAgregar.Comentarios;
          break;
        case 3: //ATENDIDO
          if (!t.objAgregar.Fecha) return;
          t.objAgregar.Fecha_cierre = null;
          t.objAgregar.Fecha_comprobacion = null;
          t.objAgregar.Comentarios_comprobacion = null;
          t.objAgregar.Fecha_resolucion = t.formateaFechaAMD(
            t.objAgregar.Fecha
          );
          t.objAgregar.Comentarios_resolucion = t.objAgregar.Comentarios;
          break;
        case 4: //COMPROBADO
          if (!t.objAgregar.Fecha) return;
          t.objAgregar.Fecha_cierre = null;
          t.objAgregar.Fecha_comprobacion = t.formateaFechaAMD(
            t.objAgregar.Fecha
          );
          t.objAgregar.Id_usuario_comprobo =
            t.getUsuarioLogueado.Usuario.Id_usuario;
          t.objAgregar.Comentarios_comprobacion = t.objAgregar.Comentarios;
          break;
        case 5: //FINALIZADO
          if (!t.objAgregar.Folio || !t.objAgregar.Fecha) return;
          t.objAgregar.Folio_cierre = t.objAgregar.Folio;
          t.objAgregar.Fecha_cierre = t.formateaFechaAMD(t.objAgregar.Fecha);
          t.objAgregar.Id_usuario_cerro =
            t.getUsuarioLogueado.Usuario.Id_usuario;
          t.objAgregar.Comentarios_cierre = t.objAgregar.Comentarios;
          break;
      }

      var ctlSrvReportes = new SrvrReportes();
      ctlSrvReportes
        .updateReporte(t, t.objAgregar)
        .then((res) => {
          if (res) {
            t.cancelarDialogoCambioEstatus();
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Reporte actualizado",
              life: 3000,
            });
            t.Filtrar();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters(["getUsuarioLogueado"]),
  },
  mounted() {
    var t = this;
    var ctlSvr = new Srvr();
    ctlSvr.getUnidades(t).then((res) => {
      t.lstUnidades = res;
    });
    this.getAllReportes();
  },
};
</script>

<style>
/* .card-margin {
  margin-bottom: 0.1rem;
} */

.card {
  border: 0;
  box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
  -moz-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
  -ms-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 2px solid #e6e4e9;
  border-radius: 8px;
}

.card .card-header.no-border {
  border: 0;
}
.card .card-header {
  background: none;
  padding: 0 0.9375rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  min-height: 50px;
}
.card-header:first-child {
  border-radius: calc(8px - 1px) calc(8px - 1px) 0 0;
}

.widget-49 .widget-49-title-wrapper {
  display: flex;
  align-items: center;
  margin-left: 0.7rem;
  margin-bottom: 0.5rem;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #edf1fc;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-primary
  .widget-49-date-day {
  color: #4e73e5;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-primary
  .widget-49-date-month {
  color: #4e73e5;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-comprobado {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #a1fa9779;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-comprobado
  .widget-49-date-day {
  color: #56ad4a;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-comprobado
  .widget-49-date-month {
  color: #56ad4a;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fcfcfd;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-secondary
  .widget-49-date-day {
  color: #dde1e9;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-secondary
  .widget-49-date-month {
  color: #dde1e9;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-success {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #e8faf8;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-success
  .widget-49-date-day {
  color: #17d1bd;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-success
  .widget-49-date-month {
  color: #17d1bd;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ebf7ff;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-day {
  color: #36afff;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-month {
  color: #36afff;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: floralwhite;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-warning
  .widget-49-date-day {
  color: #ffc868;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-warning
  .widget-49-date-month {
  color: #ffc868;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-danger {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #feeeef;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-day {
  color: #f95062;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-danger
  .widget-49-date-month {
  color: #f95062;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-light {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fefeff;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-day {
  color: #f7f9fa;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-date-light
  .widget-49-date-month {
  color: #f7f9fa;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-dark {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ebedee;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-day {
  color: #394856;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-month {
  color: #394856;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-base {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #f0fafb;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-day {
  color: #68cbd7;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
}

.widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-month {
  color: #68cbd7;
  line-height: 1;
  font-size: 1rem;
  text-transform: uppercase;
}

.widget-49 .widget-49-title-wrapper .widget-49-meeting-info {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-meeting-info
  .widget-49-pro-title {
  color: #3c4142;
  font-size: 14px;
}

.widget-49
  .widget-49-title-wrapper
  .widget-49-meeting-info
  .widget-49-meeting-time {
  font-weight: 500;
  color: #b1bac5;
  font-size: 13px;
}

.widget-49 .widget-49-meeting-points {
  font-weight: 400;
  font-size: 13px;
  margin-top: 0.5rem;
}

.widget-49 .widget-49-meeting-points .widget-49-meeting-item {
  display: list-item;
  color: #727686;
}

.widget-49 .widget-49-meeting-points .widget-49-meeting-item span {
  margin-left: 0.5rem;
}

.widget-49 .widget-49-meeting-action {
  text-align: right;
}

.widget-49 .widget-49-meeting-action a {
  text-transform: uppercase;
}

.widget-49 .detalles {
  display: block;
  margin-left: 1.5rem;
}

.widget-49 .titulo {
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: gray;
}

.widget-49 .detalles .detalle {
  font-weight: 400;
  font-size: 13px;
  color: #878d96;
}
</style>